import { render } from "./CreateClientDocumentModal.vue?vue&type=template&id=a4cd0ec6"
import script from "./CreateClientDocumentModal.vue?vue&type=script&lang=js"
export * from "./CreateClientDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__